import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { routes } from "@shared/lib/react-router";
import { SupervisionProjectsPage } from "./ui";

export const SupervisionProjectsPageRoute = (
  ...rest: RouteObject[]
): RouteObject => {
  return {
    path: `${routes.supervision.root(":projectId")}`,
    element: createElement(SupervisionProjectsPage),
    children: [...rest],
  };
};

